import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavLocalizationFactory extends NavFactory {
    protected static basePartnerPath = '/admin/partner';
    protected static items = [

        {
            code: NavItemCodes.LOCALIZATION_ACTIVATE,
            icon: IconCode.LOCALIZATION_ACTIVATE,
            label: 'LOCALIZATION.ACTIVATE',
            description: 'LOCALIZATION.ACTIVATE',
        },
        {
            code: NavItemCodes.LOCALIZATION_ADD,
            icon: IconCode.LOCALIZATION_ADD,
            label: 'LOCALIZATION.ADD',
            description: 'LOCALIZATION.ADD',
            path: ({partnerId}) => [
                NavLocalizationFactory.basePartnerPath,
                partnerId,
                'localizations',
                'add',
            ]
        },
        {
            code: NavItemCodes.LOCALIZATION_DEACTIVATE,
            icon: IconCode.LOCALIZATION_DEACTIVATE,
            label: 'LOCALIZATION.DEACTIVATE',
            description: 'LOCALIZATION.DEACTIVATE',
        },
        {
            code: NavItemCodes.LOCALIZATION_EDIT,
            icon: IconCode.LOCALIZATION_EDIT,
            label: 'LOCALIZATION.EDIT',
            description: 'LOCALIZATION.EDIT',
            path: ({partnerId, localizationId = ''}) => [
                NavLocalizationFactory.basePartnerPath,
                partnerId,
                'localization',
                localizationId,
                'edit'
            ]
        },
        {
            code: NavItemCodes.LOCALIZATION_MANAGEMENT,
            icon: IconCode.LOCALIZATION_MANAGEMENT,
            label: 'NAV.LOCALIZATION.LABEL',
            description: 'NAV.LOCALIZATION.DESC',
            path: ({partnerId}) => [NavLocalizationFactory.basePartnerPath, partnerId, 'localizations'],
            permissionArea: PermissionArea.LOCALIZATION_MANAGEMENT
        },
        {
            code: NavItemCodes.LOCALIZATION_MANAGEMENT_LIMITED,
            icon: IconCode.LOCALIZATION_LIMITED_MANAGEMENT,
            label: 'NAV.LOCALIZATION.LABEL',
            description: 'NAV.LOCALIZATION.DESC',
            path: ({partnerId}) => [NavLocalizationFactory.basePartnerPath, partnerId, 'localizations'],
            permissionArea: PermissionArea.LOCALIZATION_MANAGEMENT_LIMITED
        },
    ];
}
